var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_setup.props.modalId),expression:"props.modalId"}],staticClass:"add-site"},[_c(_setup.PlusCircleFilled,{attrs:{"width":"32","height":"32","color":_setup.PaletteColors['brand-primary']}}),_c('span',{staticClass:"title"},[_vm._v("Add a site")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }